import type { HLTradingBalance } from "@src/features/trade/hyperliquid/types"

export function getHyperliquidEquity(tradingBalance: HLTradingBalance) {
  const equity =
    tradingBalance.source === "spotUsdc"
      ? Number(tradingBalance.spotUsdc?.total)
      : Number(tradingBalance.accountState.marginSummary.accountValue)

  return Number.isFinite(equity) ? equity : 0
}
